import { execSync } from 'child_process';
import type { ExecSyncOptions } from 'child_process';
import { colors } from '../const';
import { askQuestion } from './prompts';
import { runCommandInteractive } from './exec';

const ignoreShellOptions: ExecSyncOptions = {
  stdio: 'ignore',
  shell: process.platform === 'win32' ? 'cmd.exe' : '/bin/sh',
};

export async function checkVercelLogin(useNpx: boolean): Promise<boolean> {
  console.log(`\n${colors.dim}Step 3/4: Checking Vercel Login...${colors.reset}`);
  
  const hasToken = !!process.env.VERCEL_TOKEN;
  let loggedIn = false;

  if (hasToken) {
    console.log(`✔ ${colors.green}VERCEL_TOKEN environment variable detected. Skipping login check.${colors.reset}`);
    loggedIn = true;
  } else {
    try {
      // Execute vercel whoami to check active session
      const checkCmd = useNpx ? 'npx --yes vercel whoami' : 'vercel whoami';
      execSync(checkCmd, ignoreShellOptions);
      loggedIn = true;
      console.log(`✔ ${colors.green}Logged in!${colors.reset}`);
    } catch {
      loggedIn = false;
    }
  }

  if (!loggedIn) {
    console.log(`🔑 ${colors.yellow}Not logged in to Vercel.${colors.reset}`);
    await askQuestion(`👉 Press [Enter] to login to Vercel... `);

    const loginArgs = ['login'];
    const loginCmd = useNpx ? 'npx' : 'vercel';
    const finalArgs = useNpx ? ['--yes', 'vercel', ...loginArgs] : loginArgs;

    const exitCode = await runCommandInteractive(loginCmd, finalArgs);
    if (exitCode !== 0) {
      throw new Error('Vercel login failed or was aborted.');
    }
    console.log(`\n✔ ${colors.green}Logged in successfully!${colors.reset}`);
  }

  return hasToken;
}
